export default class CustomerPaymentAccountModel {
  constructor(obj) {
    obj = obj || {};
    this.id = obj.id;
    this.bank = parseInt(obj.bank) || undefined;
    this.agency = obj.agency;
    this.account = obj.account;
    this.digit = obj.digit;
    this.createdAt = obj.createdAt;
    this.updatedAt = obj.updatedAt;
  }
}